"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AGPagination_styles_1 = __importDefault(require("./AGPagination.styles"));
var AGPagination = function () { return (react_1.default.createElement(AGPagination_styles_1.default, null)); };
exports.default = AGPagination;
